import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import AccessDenied from "../../components/accessDenied/AccessDenied";
import { PAGE_PERMISSIONS_MAPPINGS } from "../../helpers/constants";
import { getMatchedPageName } from "../../helpers/utils";
import { usePermissions } from "../../hooks/usePermissions";

type Props = {
  children: ReactNode;
  checkCountryLevelAccessOnly?: boolean;
  hasCountryLevelAccess?: boolean;
};

const PermissionProtectedRoute = ({
  children,
  checkCountryLevelAccessOnly,
  hasCountryLevelAccess,
}: Props) => {
  const { hasPagePermission } = usePermissions();
  const location = useLocation();

  const path = location.pathname;

  const matchedRoute =
    getMatchedPageName(path, PAGE_PERMISSIONS_MAPPINGS) ?? "";

  const requiredPermission = PAGE_PERMISSIONS_MAPPINGS[matchedRoute];

  //only check the country level access dose not check the page permission  [will be used edit pages]
  if (checkCountryLevelAccessOnly && !hasCountryLevelAccess) {
    return <AccessDenied />;
  }

  //only check the page permission [will be used in RouteComp]
  if (
    (!requiredPermission || !hasPagePermission(matchedRoute)) &&
    !checkCountryLevelAccessOnly &&
    !hasCountryLevelAccess
  ) {
    return <AccessDenied />;
  }

  return <>{children}</>;
};

export default PermissionProtectedRoute;
